import React, { Component, Fragment } from "react";
import SelectComponent from '../Select';
import { SpaceBox } from "../Space";
import DataService from '../../service/data';
import _ from 'lodash';
import { Alert } from "../../utils";

export default class ProvincesComponent extends Component {
    state = {
        provinceList: [],
        districtList: []
    }

    allAddress; 
    
    constructor(props) {
        super(props);
        this.initData();
    }

    async initData() {
        const { sProvince } = this.props.provinces;
        const callers = [];
        callers.push(DataService.getProvinces());

        if(sProvince) {
            callers.push(DataService.getAmphurTumbonZipCode({ province: sProvince.label }));
        }
        try {
            const responses = await Promise.all(callers);
            const lang = this.props.lang;
            const provinceList = responses[0].provinces.map(p => { 
                if(lang === "en"){
                    return { value: p.id, label: p.name_en  } 
                } else {
                    return { value: p.id, label: p.name_th  }
                }
            })

            if(callers.length > 1) {
                this.allAddress = responses[1];
                this.setAmphur();
                this.setTumbon();
            }
            this.setState({ ...this.state, provinceList });
        }
        catch {
        }
    }

    async onChangeProvince(selected) {
        const { onChange, provinces } = this.props;

        if(provinces.sProvince.value == selected.value) {
            return false;
        }
        onChange({ sProvince: selected, sDistrict: '', sCity: '', sZipcode: '' });

        //Fetch Amphur

        try {
            Alert.showLoading(); 
            this.allAddress = await DataService.getAmphurTumbonZipCode({ province: selected.label });
            Alert.hideLoading();
            this.setAmphur();
        }
        catch {
            Alert.hideLoading()
        }
      
    }
    setAmphur() {
        const lang = this.props.lang
        const amphurList = _.intersectionBy(this.allAddress, 'district_id')
        .map(d => { 
            if(lang === "en"){
                return { value: d.district_id, label: d.district_en }
            } else {
                return { value: d.district_id, label: d.district }
            }
            } )

        this.setState({ ...this.state, amphurList, tumbonList: [] });
    }

    async onChangeDistrict(selected) {
        const { onChange, provinces } = this.props;
        const { sDistrict } = provinces;
        if(sDistrict.value == selected.value) {
            return false;
        }

        onChange({ sDistrict: selected, sCity: '', sZipcode: '' });
        setTimeout(()=> this.setTumbon(), 400);
    }
    setTumbon() {
        const { sDistrict } = this.props.provinces;
        const lang = this.props.lang
        let tumbonList = _.filter(this.allAddress, { district_id: sDistrict.value})
        tumbonList = _.intersectionBy(tumbonList, 'sub_district_id')
                                .map(d => { 
                                    if(lang === "en"){
                                        return { value: d.sub_district_id, label: d.sub_district_en }
                                    } else {
                                        return { value: d.sub_district_id, label: d.sub_district}
                                    }
                                     } )

        this.setState({ ...this.state, tumbonList });
    }

    async onChangeSubDistrict(selected) {
        const { onChange, provinces } = this.props;
        const { sDistrict, sCity } = provinces;
        if(sCity.value == selected.value) {
            return false;
        }
        let address = _.filter(this.allAddress, { district_id: sDistrict.value, sub_district_id: selected.value})[0]
        onChange({ sCity: selected, sZipcode: address.zip_code });
    }


    _getLang(field) {
        const { langague,lang } = this.props
      return langague[field][lang];
    }

    _SpaceBox() {
        return <SpaceBox w={"14px"} />;
    }

    render() {
        const { sProvince, sDistrict, sCity, sZipcode = '' } = this.props.provinces || {};
        const { provinceList, amphurList, tumbonList } = this.state;

        return (
            <Fragment>
                 <div className="form-group">
                    <SelectComponent
                        placeholder={this._getLang("province")}
                        options={provinceList}
                        selected={sProvince}
                        onChange={selected =>
                            this.onChangeProvince(selected)
                        }
                    />
                </div>
                <div className="form-group">
                    <SelectComponent
                        placeholder={this._getLang("district")}
                        options={amphurList}
                        selected={sDistrict}
                        onChange={selected =>
                            this.onChangeDistrict(selected)
                        }
                    />
                </div>
                <div className="form-group">
                  <div className="d-flex flex-row">
                    <SelectComponent
                        placeholder={this._getLang("subDistrict")}
                        options={tumbonList}
                        selected={sCity}
                        onChange={selected =>
                            this.onChangeSubDistrict(selected)
                        }
                        // onChange={selected =>
                        //     onChangeOther({ name: "sCity", value: selected })
                        // }
                    />
                    {this._SpaceBox()}
                    <input
                        // id={sProvince}
                        type="text"
                        className="form-control"
                        placeholder={this._getLang("postCode")}
                        name="sZipcode"
                        readOnly
                        disabled
                        value={sZipcode}
                    />
                  </div>
                </div>
            </Fragment>
        )
    }
}